import { createLucideIcon } from 'lucide-react';
export const LogoutCircle = createLucideIcon('logout-circle', [
  [
    'path',
    {
      d: 'M18 17.6615C14.7973 20.7795 9.60471 20.7795 6.40202 17.6615C3.19933 14.5434 3.19933 9.4881 6.40202 6.37006C6.40202 6.37006 11.1759 1.03743 18 6.37006',
      key: 'ud1orr',
    },
  ],
  [
    'path',
    {
      d: 'M20 11.8743L17.4615 15',
      key: 'zf9k7p',
    },
  ],
  [
    'path',
    {
      d: 'M20 11.8743L17.4615 9',
      key: '1ay89e',
    },
  ],
  [
    'path',
    {
      d: 'M9 11.8743H20',
      key: '9kzgsi',
    },
  ],
]);
